import styled from '@emotion/styled';
import { Article } from 'lib/articles';
import Link from 'next/link';
import React, { forwardRef } from 'react';
import { trackArticle } from 'reusable/ChargeGTM';
import { ImageContainer, LeftArrowShort, NewText } from 'ui';
import { sharedColors } from 'ui/theme/colors';
import { getNonUmbracoURL } from 'utils/utils';

const CardContainer = styled.div<{ width?: number, height?: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  width: ${(p) => p.width ? `${p.width}px` : "100%"};
  height: ${(p) => p.height ? `${p.height}px` : "100%"};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${sharedColors.blue};
`;

const StyledText = styled.div``;

const StyledTextAndButton = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;

const StyledLinkText = styled.div`
  padding-top: 10px;
  display: flex;
  align-items: center;
  :hover {
    text-decoration: underline;
  }
`;

type CardProps = {
  article: Article;
  position: number;
  withLink?: boolean;
  onClickAddedLogic?: () => void;
  width?: number;
  height?: number;
};

// Forward the ref in the component
const ArticleCard = forwardRef<HTMLAnchorElement, CardProps>(
  ({ article, withLink = true, position, width, height, onClickAddedLogic }, ref) => {
    const { name, desktopImage, mobileImage, url } = article;

    const handleTrackClick = () => {
      if (onClickAddedLogic) {
        onClickAddedLogic();
      }
    };

    return (
      <CardContainer  width={width} height={height}>
        <ImageContainer
          desktopUrl={desktopImage}
          mobileUrl={mobileImage || desktopImage}
          height={200}
          mediumHeight={200}
          mobileHeight={158}
          sm={true}
          alt={name || ""}
        />
        <StyledTextAndButton>
          <StyledText>
            <NewText
              component={"p"}
              largeDesktopFontSize={18}
              largeDesktopLineHeight="20px"
              desktopFontSize={18}
              desktopLineHeight={"20px"}
              mobileFontSize={18}
              mobileLineHeight={"18px"}
              desktopFontWeight={400}
              color={sharedColors.black}
            >
              {name}
            </NewText>
          </StyledText>
          {withLink && (
            <StyledLink href={getNonUmbracoURL(url)} onClick={handleTrackClick} ref={ref} aria-label={article.name}>
              <StyledLinkText>
                <NewText
                  component={"p"}
                  largeDesktopFontSize={18}
                  largeDesktopLineHeight="20px"
                  desktopFontSize={18}
                  desktopLineHeight={"20px"}
                  mobileFontSize={18}
                  mobileLineHeight={"18px"}
                  desktopFontWeight={500}
                  color={sharedColors.blue}
                >
                  להמשך הכתבה
                </NewText>
                <LeftArrowShort color={sharedColors.blue}></LeftArrowShort>
              </StyledLinkText>
            </StyledLink>
          )}
        </StyledTextAndButton>
      </CardContainer>
    );
  }
);
export default ArticleCard;
